import { Box } from "@mui/material";

import { usePageTitle } from "@/hooks/use-page-title";
import HeroSection from "@/components/home/hero-section";
import ProblemSection from "@/components/home/problem-section";
import WhatYouGetSection from "@/components/home/what-you-get-section";
import HowItWorksSection from "@/components/home/how-it-works-section";
import SupportedProgramsSection from "@/components/home/supported-programs-section";
import FaqSection from "@/components/home/faq-section";
import PlatformContextSection from "@/components/home/platform-context-section";
import CtaSection from "@/components/home/cta-section";

/**
 * Landing page narrative arc, matching the rest of the platform's marketing
 * pages (see calendar's/docs' src/pages/home.tsx): full-bleed hero, feature
 * content, a "part of the platform" ecosystem section, then a closing CTA.
 * Each section manages its own full-width background and internal
 * Container — this page has no outer max-width wrapper so those backgrounds
 * reach the true viewport edge.
 */
export default function Landing(): React.JSX.Element {
  usePageTitle();

  return (
    <Box>
      <HeroSection />
      <ProblemSection />
      <WhatYouGetSection />
      <HowItWorksSection />
      <SupportedProgramsSection />
      <FaqSection />
      <PlatformContextSection />
      <CtaSection />
    </Box>
  );
}
